// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccordionSectionHeader, AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import ChevronDown from "@sc/XDL/Icons/ChevronDown";
import ChevronUp from "@sc/XDL/Icons/ChevronUp";
import { xBaseTheme } from "@sc/XDL/types";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        titleTypographyProps: {
            variant: "h3",
            forwardAs: "span",
            weight: "bold",
            color: "text.main",
            size: 20,
            css: css`
                margin-bottom: 0;
            `,
        },
        toggleIconProps: {
            color: "primary.main",
            src: ChevronUp,
            size: 20,
            css: css`
                &${IconWrapper}, svg {
                    width: 15px;
                    height: 20px;
                }
                &:hover {
                    color: ${color("common.ui8")};
                }
            `,
        },
        expandIconProps: {
            src: ChevronDown,
            css: css`
                &${IconWrapper}, svg {
                    width: 15px;
                    height: 20px;
                }
                &:hover {
                    color: ${color("common.ui8")};
                }
            `,
        },
        headerProps: {
            css: css`
                background: ${color("common.background")};

                button {
                    padding: 0 0 8px;
                    border: 0;
                    border-bottom: 1px solid ${color("common.border")};
                    background: ${color("common.background")};
                }

                &&& button,
                &&& ${/* sc-selector */ AccordionSectionPanel} + & button {
                    &:focus {
                        outline-width: 0;
                        padding: 0 0 8px;
                        border-bottom: 1px solid ${color("common.border")};
                    }
                }
                ${({ expanded }: AccordionSectionHeaderProps) =>
                    !expanded &&
                    css`
                        &&& button,
                        &&& button:focus {
                            margin-bottom: 32px;
                        }
                        &&& button,
                        &&& button:focus,
                        ${AccordionSectionPanel} + & button:focus {
                            border-bottom-color: ${color("common.border")};
                        }
                    `}
            `,
        },
        panelProps: {
            css: css`
                padding: 10px 0 0;
                border: 0;
                line-height: 26px;
                margin-bottom: 32px;
            `,
        },
    },
} as xBaseTheme["accordion"];
